import HeroSection from '../../sections/HeroSection/HeroSection';
import { ThemeProvider } from 'styled-components';
import theme from '../../global/theme';
import CTASection from '../../sections/CalltoActionSection/CalltoActionSection';
import { GlobalStyle } from '../../global/global';
import {
    Box,
    Flex,
    Text,
    Image,
    UnorderedList,
    ListItem,
    Link,
    List,
    ListIcon,
    Show,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    Button,
    useDisclosure,
    Grid,
    Heading,
    AspectRatio,
} from '@chakra-ui/react';
import FAQ from '../../sections/Faq/Faq';
import ChakraTilesSection from '../../sections/ChakraTilesSection/ChakraTilesSection';
import WhyService from '../../sections/WhyService/WhyService';
import BenefitsSectionWithImage from '../../sections/BenefitsSectionWithImage/BenefitsSectionWithImage';
import ExtendedTabsSection from '../../sections/ExtendedTabsSection/ExtendedTabsSection';
import { CheckIcon, AddIcon, PlusSquareIcon } from '@chakra-ui/icons';
import { ButtonContainer } from '../../sections/MigrationSection/styles';
import StyledButton from '../../components/Button/Button';
import ContactSection from '../../sections/ContactSection/ContactSection';
import ContentImage from '../../sections/ContentImageSection/ContentImageSection';
import FormSection from '../../sections/FormSection/FormSection';
import TilesSection from '../../sections/TilesSection/TilesSection';
import SectionWithPlusTick from '../../sections/SectionWithPlusTick/SectionWithPlusTick';

interface Props {}

const heroImage = {
    url: 'https://www.idosell.com/panel/file-gate.php?id=611128&ext=.jpeg',
    alt: 'Zdjęcie wyróżniające w hero - IdoSell RS',
};

export default function RsPage(props: Props) {
    return (
        <ThemeProvider theme={theme}>
            <GlobalStyle $whiteColor />
            <HeroSection
                title="Inteligentne rekomendacje produktowe IdoSell"
                subTitle="Włącz IdoSell RS I prezentuj rekomendacje produktowe dopasowane do preferencji Twojego klienta."
                image={heroImage}
                paddingDesktop="75px 0"
                gap="0"
            />
            <div className="homepage containerIdosellPages">
                <Box
                    p={{ base: '20px 0', lg: '50px 0 112.5px 0' }}
                    display={'flex'}
                    flexDirection={'column'}
                    gap={'50px'}
                    position={'relative'}
                >
                    <Box>
                        <Box
                            display={'flex'}
                            gap={'30px'}
                            alignItems={'center'}
                            flexDir={{ base: 'column', lg: 'row' }}
                        >
                            <Box width={{ base: '100%', lg: '50%' }}>
                                <Show above="lg">
                                    <Image
                                        src="https://www.idosell.com/panel/file-gate.php?id=611129&ext=.png"
                                        alt=""
                                    ></Image>
                                </Show>
                                <Show below="lg">
                                    <Image
                                        src="https://www.idosell.com/panel/file-gate.php?id=611130&ext=.png"
                                        alt=""
                                    ></Image>
                                </Show>
                            </Box>
                            <Box
                                display={'flex'}
                                flexDir={'column'}
                                alignItems={'flex-start'}
                                width={{ base: '100%', lg: '50%' }}
                                padding={'30ox'}
                            >
                                <Text
                                    fontSize={'34px'}
                                    lineHeight={'1.5'}
                                    fontWeight={'600'}
                                    color={'#171717'}
                                    mb="15px"
                                >
                                    Rekomendacje, które sprzedają
                                </Text>
                                <Text color={'#171717'} fontSize={'18px'} marginBottom={'15px'}>
                                    IdoSell RS to zaawansowany system rekomendacji produktowych,
                                    który personalizuje ofertę w Twoim sklepie internetowym.
                                </Text>
                                <Text color={'#171717'} fontSize={'18px'} marginBottom={'30px'}>
                                    Dzięki analizie zachowań użytkowników i technologii machine
                                    learning system wyświetla klientom produkty idealnie dopasowane
                                    do ich zainteresowań.
                                </Text>
                                <Text color={'#171717'} fontSize={'18px'} marginBottom={'45px'}>
                                    Zaawansowane algorytmy sztucznej inteligencji i technologia
                                    collaborative filtering pozwalają nie tylko określić
                                    podobieństwa między towarami, ale także precyzyjnie dopasować
                                    rekomendacje do preferencji kupujących. Efekt? Większe
                                    zaangażowanie klientów, wyższa konwersja i więcej sprzedaży.
                                </Text>
                                <Link
                                    href="https://www.idosell.com/pl/dashboard/"
                                    background={'#171717'}
                                    color={'white'}
                                    padding={'12px 30px'}
                                    fontSize={'16px'}
                                    fontWeight={'600'}
                                    display={'flex'}
                                    alignItems={'center'}
                                    gap={'10px'}
                                    _hover={{
                                        underline: 'none',
                                        background: 'rgba(11, 113, 83, 0.5)',
                                    }}
                                >
                                    Włącz IdoSell RS
                                    <svg
                                        width="9"
                                        height="14"
                                        viewBox="0 0 9 14"
                                        fill="white"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path d="M0 13.6H2.70588L8.4 6.98565L2.70588 0.400024H0L5.69412 6.98565L0 13.6Z" />
                                    </svg>
                                </Link>
                            </Box>
                        </Box>
                    </Box>
                </Box>
                <TilesSection
                    title={'Zwiększ konwersję i wartość koszyka dzięki IdoSell RS'}
                    tiles={[
                        {
                            title: 'Pełna integracja i wsparcie',
                            content:
                                'IdoSell RS działa bezpośrednio w panelu IdoSell, a jego wdrożenie i pełne wsparcie techniczne są całkowicie bezpłatne.',
                        },
                        {
                            title: 'Bezpłatne dostosowanie szablonu',
                            content:
                                'Jeśli Twój szablon nie obsługuje rekomendacji, dostosujemy go za darmo, aby IdoSell RS działał w Twoim sklepie bez problemu.',
                        },
                        {
                            title: 'Statystyki i monitoring efektów',
                            content:
                                'Analizuj skuteczność rekomendacji w czasie rzeczywistym dzięki pełnemu dostępowi do statystyk w panelu IdoSell. Personalizowane rekomendacje możesz wdrożyć także w newsletterze.',
                        },
                        {
                            title: 'Tylko dostępne produkty',
                            content:
                                'IdoSell RS zawsze pokazuje wyłącznie dostępne towary, eliminując ryzyko proponowania niedostępnych produktów.',
                        },
                        {
                            title: 'Searching Pro za darmo',
                            content:
                                'Włączając IdoSell RS, otrzymujesz Searching Pro bez dodatkowych opłat! Sprawdź szczegóły.',
                        },
                        {
                            title: 'Elastyczne rozliczenie',
                            content:
                                'Wybierz model płatności dopasowany do Twojego biznesu – stała opłata miesięczna lub prowizja od sprzedaży. Skontaktuj się z nami, aby poznać szczegóły.',
                        },
                    ]}
                />
                <SectionWithPlusTick
                    alignItems={'center'}
                    display={'flex'}
                    flexDirection={'column'}
                    background={'#1AAC7A'}
                    p={'50px 0'}
                    imagePosition="right"
                    ctaButton={{
                        label: 'Przetestuj Searching Pro za darmo',
                        href: 'https://www.idosell.com/pl/tysiace-gotowych-do-uzycia-funkcji/searching-pro/',
                    }}
                    imageResponsive={{
                        base: {
                            url: 'https://www.idosell.com/panel/file-gate.php?id=611132&ext=.webp',
                            alt: 'Zdjęcie bannerowe - searching pro - mobile',
                        },
                        md: {
                            url: 'https://www.idosell.com/panel/file-gate.php?id=611131&ext=.webp',
                            alt: 'Zdjęcie bannerowe - searching pro',
                        },
                    }}
                    additionalParagraph="Ponad 50% zamówień w e-commerce zaczyna się od wyszukiwarki sklepowej. Spraw, by Twoi klienci szybciej znajdowali to, czego szukają, i zwiększ swoją sprzedaż dzięki Searching Pro w IdoSell."
                    tickItem={[
                        {
                            title: 'Podpowiedzi i autokorekta',
                            text: 'Nie musisz martwić się literówkami – Searching Pro automatycznie koryguje błędy i sugeruje najczęściej wyszukiwane frazy, ułatwiając klientom zakupy.',
                        },
                        {
                            title: 'Wyświetlanie dostępnych towarów',
                            text: 'Twoi klienci zobaczą najpierw produkty dostępne w magazynie – bez względu na wybrane sortowanie.',
                        },
                        {
                            title: 'Analiza wyszukiwań klientów',
                            text: 'Sprawdź, jakie frazy wpisują użytkownicy i optymalizuj ofertę. Jeśli jakieś zapytanie zwraca puste wyniki, łatwo przekierujesz je na najlepiej dopasowane produkty.',
                        },
                    ]}
                />
                <Box p={{ base: '20px 0', lg: '50px 0 100px 0' }}>
                    <Flex flexDirection={'column'}>
                        <Text
                            fontSize={{ base: '30px', md: '34px' }}
                            lineHeight={'1.5'}
                            fontWeight={'600'}
                            color={'#171717'}
                            as="b"
                            textAlign="center"
                            marginBottom={'10px'}
                        >
                            Jak inteligentne rekomendacje pomagają w rozwoju sklepu LokiKoki.pl?
                        </Text>
                        <Text
                            fontSize="18px"
                            color={'#171717'}
                            fontWeight={'400'}
                            mb="5px"
                            textAlign="center"
                            marginBottom={'60px'}
                        >
                            Chcesz zwiększyć swoje obroty, średnią wartość zamówienia i satysfakcję
                            klientów, którzy kupują w twoim sklepie internetowym? Sprawdź, jak
                            działa IdoSell RS - inteligentny system rekomendacji produktowych, który
                            wykorzystuje nauczanie maszynowe.
                        </Text>
                    </Flex>
                    <Flex
                        gap={{ base: '0', md: '30px' }}
                        flexDirection={{ base: 'column', lg: 'row' }}
                    >
                        {/* Sekcja tekstowa */}
                        <Flex
                            flexBasis={{ base: '100%', md: '370px' }}
                            maxW={{ base: '100%', md: '370px' }}
                            flexShrink={0}
                            flexDir="column"
                            p="30px"
                            bg="#1AAC7A"
                            flex="1"
                        >
                            <Text
                                mb="15px"
                                color="white"
                                fontSize={{ base: '30px', md: '34px' }}
                                fontWeight="bold"
                            >
                                Zwiększ sprzedaż dzięki inteligentnym podpowiedziom
                            </Text>
                            <Text fontSize="18px" color="white">
                                Obejrzyj webinar i zobacz, jak LokiKoki.pl wykorzystuje IdoSell RS
                                do poprawy wyników sprzedażowych i konwersji.
                            </Text>
                        </Flex>

                        {/* Sekcja wideo */}
                        <Flex maxW={{ base: '100%', md: 'calc(100% - 370px - 30px)' }} flex="1">
                            <AspectRatio ratio={16 / 9} w="100%">
                                <iframe
                                    src="https://www.idosell.com/panel/video-gate.php?id=374&lang=pl&branch=shop"
                                    title="YouTube video player"
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                    referrerPolicy="strict-origin-when-cross-origin"
                                    allowFullScreen
                                />
                            </AspectRatio>
                        </Flex>
                    </Flex>
                </Box>
                <ContactSection />
            </div>
        </ThemeProvider>
    );
}
